import { type Property } from 'csstype'

import { remToNumberOfPixels } from '@Utils/units'

export const getInnerBorderRadius = (
  outerBorderRadius: string | undefined,
  margin: string | undefined,
): Property.BorderRadius<string | number> | undefined => {
  if (!outerBorderRadius || outerBorderRadius === '0' || !margin || margin === '0' || outerBorderRadius.includes('%')) {
    return outerBorderRadius
  }

  if (remToNumberOfPixels(outerBorderRadius) - remToNumberOfPixels(margin) <= 0) {
    return `calc(${outerBorderRadius} / 2)`
  }

  return `calc(${outerBorderRadius} - ${margin})`
}
